const Style = `
  <style>
    h3 {
      font-size: 18px;
      font-weight: normal;
      line-height: 28px;
    }

    p {
      font-size: 14px;
      color: #717575;
    }

    .error {
      font-size: 12px;
      color: #CE5347;
    }

    .customization-option-wrapper {
      display: flex;
      justify-content: start;
      gap: 12px;
      flex-wrap: wrap;
      list-style: none;
      padding: 0;
    }

    .customization-option-wrapper li {
      width: 180px;
      height: 50px;
      font-size: 14px;
      display: flex;
      align-items: center;
      border-radius: 11px;
      justify-content: center;
      border: 1px solid #C3C7C7;
    }

    .customization-option {
      cursor: pointer;
    }

    .customization-option.selected {
      background: #F1F9F7;
      border: 1px solid #8AE5D3;
    }

    .buttons-wrapper {
      display: flex;
    }

    @media (max-width: 768px) {
      .customization-option-wrapper {
        justify-content: space-around;
      }

      .customization-option-wrapper li {
        width: 130px;
        font-size: 12px;
      }
    }
  </style>
`;

export default Style;
